// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { emptyFn } from './common';

/**
 * @class Jsw.ModalDialogBox
 * @extends Jsw.Component
 */
export const ModalDialogBox = Class.create(Component, {
    initialize($super, config) {
        $super(config);
        this._componentElement.select('[autofocus]').forEach(el => el.focus());
    },

    _initConfiguration($super, config) {
        $super(config);

        this._screenDisablerId = this._getConfigParam('screenDisablerId', 'screenDisabler');
        this._hideOnEscape = this._getConfigParam('hideOnEscape', false);
        this._hideOnBgClick = this._getConfigParam('hideOnBgClick', true);
        this._onShow = this._getConfigParam('onShow', emptyFn);
        this._onHide = this._getConfigParam('onHide', emptyFn);

        if (!$(this._screenDisablerId)) {
            ModalDialogBox.initScrollbarSpacer();
            $(document.body).insert({
                top: `<div id="${this._screenDisablerId}" class="main-disabled-block"></div>`,
            });
        }

        this._screenDisabler = $(this._screenDisablerId);

        const renderTo = this._getConfigParam('renderTo', 'modalDialogBox');
        this._renderTarget = $(renderTo) || new Element('div', { id: renderTo });

        this._renderTarget.update('');
        this._screenDisabler.insert({ after: this._renderTarget });
        this._onKeyDownhandler = this._onKeyDown.bind(this);
    },

    _addEvents($super) {
        $super();

        if (this._hideOnBgClick) {
            this._componentElement.observe('click', function () {
                this.hide();
            }.bind(this));
        }

        const popupContainer = this._componentElement.down('.popup-container');
        if (popupContainer) {
            popupContainer.observe('click', function (e) {
                e.stopPropagation();
            });
        }

        this._onKeyDownhandler = this._onKeyDown.bind(this);
    },

    show($super) {
        $super();
        $$('html')[0].addClassName('modal-open');
        document.observe('keydown', this._onKeyDownhandler);
        this._onShow();
    },

    hide($super) {
        $super();
        $$('html')[0].removeClassName('modal-open');
        document.stopObserving('keydown', this._onKeyDownhandler);
        this._onHide();
    },

    _onKeyDown(e) {
        switch (e.keyCode) {
            case (this._hideOnEscape && Event.KEY_ESC):
                this.hide();
                break;
        }
    },
});

ModalDialogBox.initScrollbarSpacer = function () {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);

    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    const styleEl = document.createElement('style');
    document.head.appendChild(styleEl);
    styleEl.sheet.insertRule(`.modal-open {margin-right: ${scrollbarWidth}px}`, 0);
    styleEl.sheet.insertRule(`.modal-open .js-scrollbar-spacer {margin-right: ${scrollbarWidth}px}`, 1);
};



// WEBPACK FOOTER //
// ./jsw/modal-dialog-box.js